import React, { Component } from 'react'
import { Input } from '@driftt/tide-core'

class StringInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentValue: props.value || ''
    }
  }

  handleChange = ({target: { value }}) => {
    const { onChange } = this.props

    this.setState({
      currentValue: value
    })

    onChange(value)
  }

  render() {
    const { currentValue } = this.state

    return (
        <Input
          {...this.props}
          className="contact-details--typed-input--string"
          onChange={this.handleChange}
          value={currentValue}
          placeholder={'Enter string value…'}
          type="text"
        />
    )
  }
}

export default StringInput
